import Tag from "./Tag";

export default class Analytics {
    name: string = null;
    started: number = 0;
    fails: number = 0;
    completed: number = 0;
    decisions: number = 0;
    positiveTotal: number = 0;
    highestPositiveTotal: number = 0;
    negativeTotal: number = 0;
    positiveHuge: number = 0;
    positiveLarge: number = 0;
    positiveMedium: number = 0;
    positiveSmall: number = 0;
    positiveTiny: number = 0;
    negativeTiny: number = 0;
    negativeSmall: number = 0;
    negativeMedium: number = 0;
    negativeLarge: number = 0;
    negativeHuge: number = 0;
    upliftScore: number = 0;
    upliftPositive: number = 0;
    tags:Array<Tag> = [];
}



// WEBPACK FOOTER //
// ./src/objects/Analytics.ts